import config from 'config';
import moment from 'moment';
import { authorUrl, formatDateOrDateTime } from '../../../../src/utils';
import _ from 'lodash';

const authorTemplate = (author) => {
  return {
    '@type': author.type,
    name: author.name,
    url: config.host + author.url
  };
};

const Article = (props) => {
  const published = props.Date ? formatDateOrDateTime(props.Date) : moment().format();
  const modified = props.ModifiedDate ? formatDateOrDateTime(props.ModifiedDate) : published;
  const datePublished = published;
  const dateModified = modified || published;

  const image = props.ogImage === undefined ? '/media-library/facebook-share-img.jpg' : props.ogImage;
  const imageUrl = `${config.host}${image}`;

  let authors = [];

  if (props.Author && typeof props.Author === 'string') {
    authors = [
      {
        type: 'Person',
        name: props.Author,
        url: authorUrl(props.Author)
      }
    ];
  } else if (_.isArray(props.Author)) {
    authors = props.Author.map((author) => ({
      type: 'Person',
      name: author,
      url: authorUrl(author)
    }));
  } else {
    console.error('Blog is missing Author metadata');
  }

  const formattedAuthors = authors.map((item) => authorTemplate(item));

  return `{
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "${config.host + props.pathName}"
    },
    "url": "${config.host + props.pathName}",
    "headline": "${props.Title}",
    "datePublished": "${datePublished}",
    "dateModified": "${dateModified}",
    "image": "${imageUrl}",
    ${
      props.pathName.startsWith('/blog/')
        ? `"articleSection": "${props.Categories && props.Categories.length ? props.Categories[0] : ''}",`
        : ''
    }
    "publisher": {
      "@type": "Organization",
      "name": "Starling Bank",
      "logo": {
        "@type": "ImageObject",
        "url": "${config.host}/permanent-assets/Starling-Logo-600x60.png",
        "width": 600,
        "height": 60
      }
    },
    "description": "${props.Description}"${formattedAuthors.length ? ',' : ''}
    ${formattedAuthors.length ? `"author": ${JSON.stringify(formattedAuthors)}` : ''}
  }`;
};

export default Article;
